import Vue from 'vue'
import VueRouter from 'vue-router'

const index = r => require.ensure([], () => r(require('../views/home/index')), 'index');
const googleCallback = r => require.ensure([], () => r(require('../views/oauth/googleCallback')), 'googleCallback');
const tiktokCallback = r => require.ensure([], () => r(require('../views/oauth/tiktokCallback')), 'tiktokCallback');
const news = r => require.ensure([], () => r(require('../views/news/list')), 'news');
const newsInfo = r => require.ensure([], () => r(require('../views/news/info')), 'newsInfo');
const details = r => require.ensure([], () => r(require('../views/details/details')), 'details');
const fixturePoster = r => require.ensure([], () => r(require('../views/poster/index')), 'fixturePoster');
const viewPoster = r => require.ensure([], () => r(require('../views/poster/viewPoster')), 'viewPoster');
const about = r => require.ensure([], () => r(require('../views/about/about')), 'about');
const privacy = r => require.ensure([], () => r(require('../views/policy/privacy')), 'privacy');
const terms = r => require.ensure([], () => r(require('../views/policy/terms')), 'terms');
const page404 = r => require.ensure([], () => r(require('../views/404')), 'page404');
const prediction = r => require.ensure([], () => r(require('../views/prediction/index')), 'prediction');

Vue.use(VueRouter)

const scrollToTop = () => {
    return { x: 0, y: 0 } // 这里表示目标位置为页面左上角
}

const router = new VueRouter({
    //mode: 'hash',
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
          return savedPosition;
        } else {
          return to.hash ? { selector: to.hash } : scrollToTop();
        }
    },
    routes: [
        {
            path: '/',
            name: 'index',
            component: index,
            meta: {
                title: '首页'
            }
        },
        {
            path: '/oauth/googleCallback',
            name: 'googleCallback',
            component: googleCallback,
            meta: {
                title: 'google登录回调'
            }
        },
        {
            path: '/oauth/tiktokCallback',
            name: 'tiktokCallback',
            component: tiktokCallback,
            meta: {
                title: 'tiktok登录回调'
            }
        },
        {
            path: '/news/:categoryId',
            name: 'news',
            component: news,
            meta: {
                title: '新闻列表'
            }
        },
        {
            path: '/newsInfo/:id/:title?',
            name: 'newsInfo',
            component: newsInfo,
            meta: {
                title: '新闻详情'
            }
        },
        {
            path: '/details/:tab/:id/:title?',
            name: 'details',
            component: details,
            // meta: {
            //     title: '比赛内页'
            // }
        },
        {
            path: '/fixturePoster',
            name: 'fixturePoster',
            component: fixturePoster,
            meta: {
                title: '海报列表'
            }
        },
        {
            path: '/viewPoster/:id',
            name: 'viewPoster',
            component: viewPoster,
            meta: {
                title: '查看海报'
            }
        },
        {
            path: '/about',
            name: 'about',
            component: about,
            meta: {
                title: '关于我们'
            }
        },
        {
            path: '/terms',
            name: 'terms',
            component: terms,
            meta: {
                title: '服务协议'
            }
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: privacy,
            meta: {
                title: '隐私协议'
            }
        },
        {
            path: '/prediction',
            name: 'prediction',
            component: prediction,
            meta: {
                title: '预测列表'
            }
        },
        {
            path: '/404',
            name: '404',
            component: page404,
            meta: {
                title: '404'
            }
        },
    ]
})
export function createRouter () {
    return router
}



// WEBPACK FOOTER //
// ./src/router/index.js